import { render, staticRenderFns } from "./Create-Project.vue?vue&type=template&id=58d2af0b&scoped=true"
import script from "./Create-Project.vue?vue&type=script&lang=js"
export * from "./Create-Project.vue?vue&type=script&lang=js"
import style0 from "./Create-Project.vue?vue&type=style&index=0&id=58d2af0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d2af0b",
  null
  
)

export default component.exports